export default {
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  error: () => import("/app/layouts/error.vue").then(m => m.default || m),
  private: () => import("/app/layouts/private.vue").then(m => m.default || m),
  public: () => import("/app/layouts/public.vue").then(m => m.default || m),
  responsive: () => import("/app/layouts/responsive.vue").then(m => m.default || m),
  website: () => import("/app/layouts/website.vue").then(m => m.default || m)
}